import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "visible",
  "use": "visible-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"visible\"><title>visible</title><g id=\"visible__visibility\"><g id=\"visible__visibility-2\" data-name=\" visibility\"><path d=\"M18.9,10.2c-.15-.21-3.79-5.05-8.4-5.05S2.25,10,2.1,10.2l-.22.3.22.3c.15.21,3.79,5.05,8.4,5.05S18.75,11,18.9,10.8l.22-.3Zm-8.4,4.3a4,4,0,1,1,4-4A4,4,0,0,1,10.5,14.5Zm-7.36-4A15.3807,15.3807,0,0,1,6.58,7.43a4.89,4.89,0,0,0,0,6.14A15.3807,15.3807,0,0,1,3.14,10.5Zm11.28,3.07a4.89,4.89,0,0,0,0-6.14,15.3807,15.3807,0,0,1,3.44,3.07A15.3807,15.3807,0,0,1,14.42,13.57Z\" /><circle cx=\"10.5\" cy=\"10.5\" r=\"2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/visible.svg
// module id = CzFf
// module chunks = 4